import React, { useState } from "react";

const RefundPolicy = () => {
  const [open, setOpen] = useState(null);
  const toggle = (id) => setOpen(open === id ? null : id);

  return (
    <div style={s.page}>
      <style>{css}</style>
      <div style={s.wrap}>

        {/* Hero */}
        <div style={s.hero}>
          <div style={s.badge}>Refund & Cancellation Policy</div>
          <h1 style={s.h1}>Transparent & Fair Refund Policy</h1>
          <p style={s.heroSub}>
            We want you to be confident in your subscription to Tracklio Hub. Please read our
            refund and cancellation terms carefully before subscribing.
          </p>
          <p style={s.heroDate}>Last updated: June 25, 2026 &nbsp;·&nbsp; Applicable to: All Tracklio Hub Subscriptions</p>
        </div>

        {/* Summary Cards */}
        <div style={s.summaryGrid}>
          <div style={{ ...s.summaryCard, borderTop:"3px solid #22c55e" }}>
            <div style={s.summaryIcon}>✅</div>
            <strong>7-Day Free Trial</strong>
            <p>All new plans include a 7-day free trial. No charge if cancelled before trial ends.</p>
          </div>
          <div style={{ ...s.summaryCard, borderTop:"3px solid #3b82f6" }}>
            <div style={s.summaryIcon}>🔄</div>
            <strong>Pro-Rata Refunds</strong>
            <p>Annual plan subscribers get pro-rata refund for unused months (after 30 days).</p>
          </div>
          <div style={{ ...s.summaryCard, borderTop:"3px solid #f59e0b" }}>
            <div style={s.summaryIcon}>📅</div>
            <strong>Monthly Plans</strong>
            <p>Monthly subscriptions are non-refundable after 48 hours of billing.</p>
          </div>
          <div style={{ ...s.summaryCard, borderTop:"3px solid #ef4444" }}>
            <div style={s.summaryIcon}>🚫</div>
            <strong>Non-Refundable Items</strong>
            <p>Setup fees, custom development, white-label fees, and SMS/Email credits are non-refundable.</p>
          </div>
        </div>

        {/* Accordion Sections */}
        <div style={s.accordion}>

          {/* 1 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(1)}>
              <span style={s.accNum}>01</span>
              <span style={s.accTitle}>Free Trial Policy</span>
              <span style={{ ...s.accChev, transform: open===1?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===1 && <div style={s.accBody}>
              <ul>
                <li>All new Tracklio Hub subscriptions include a <strong>7-day free trial</strong> with full access to your chosen plan's modules.</li>
                <li>No credit card or payment is required to start the free trial.</li>
                <li>If you do not subscribe after the trial, your account is automatically downgraded to the free tier.</li>
                <li>If you subscribe during the trial and cancel within <strong>7 days of your first payment</strong>, you are eligible for a full refund.</li>
                <li>Free trial is available once per company/organization. Creating multiple accounts to exploit the trial is a violation of our Terms of Service.</li>
              </ul>
            </div>}
          </div>

          {/* 2 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(2)}>
              <span style={s.accNum}>02</span>
              <span style={s.accTitle}>Monthly Subscription Refunds</span>
              <span style={{ ...s.accChev, transform: open===2?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===2 && <div style={s.accBody}>
              <ul>
                <li>Monthly subscription fees are billed at the start of each billing cycle.</li>
                <li>Refund requests submitted within <strong>48 hours</strong> of a monthly billing date will be considered for a full refund.</li>
                <li>After 48 hours, monthly subscription fees are <strong>non-refundable</strong> as service access has been provided.</li>
                <li>You may cancel your monthly subscription at any time. Cancellation takes effect at the end of the current billing cycle — you retain access until then.</li>
                <li>No partial refunds are issued for unused days within a monthly billing period.</li>
              </ul>
              <div className="policy-note yellow">
                ⚠️ To avoid being charged for the next month, cancel at least 24 hours before your renewal date.
              </div>
            </div>}
          </div>

          {/* 3 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(3)}>
              <span style={s.accNum}>03</span>
              <span style={s.accTitle}>Annual Subscription Refunds</span>
              <span style={{ ...s.accChev, transform: open===3?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===3 && <div style={s.accBody}>
              <ul>
                <li>Annual subscriptions are eligible for a <strong>pro-rata refund</strong> for unused complete months remaining, minus a processing fee of ₹500 or 5% of the refund amount (whichever is higher).</li>
                <li>Refund requests must be submitted within the <strong>first 30 days</strong> of the annual billing date for a full refund.</li>
                <li>After 30 days, pro-rata refund for remaining months is applicable.</li>
                <li>After <strong>10 months</strong> of an annual subscription, no refund is applicable as the remaining period is 2 months or less.</li>
                <li>Annual plan cancellations are effective immediately upon confirmation. Access is not provided during the refund processing period.</li>
              </ul>
              <div className="policy-table-wrap">
                <table className="policy-table">
                  <thead>
                    <tr>
                      <th>Time Since Annual Payment</th>
                      <th>Refund Eligibility</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>Within 7 days (trial)</td><td className="green">Full Refund</td></tr>
                    <tr><td>Day 8 – Day 30</td><td className="green">Full Refund (minus ₹500 fee)</td></tr>
                    <tr><td>Month 2 – Month 10</td><td className="yellow">Pro-Rata Refund for remaining months</td></tr>
                    <tr><td>Month 11 – Month 12</td><td className="red">No Refund</td></tr>
                  </tbody>
                </table>
              </div>
            </div>}
          </div>

          {/* 4 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(4)}>
              <span style={s.accNum}>04</span>
              <span style={s.accTitle}>Non-Refundable Items</span>
              <span style={{ ...s.accChev, transform: open===4?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===4 && <div style={s.accBody}>
              <p>The following are <strong>strictly non-refundable</strong> under any circumstances:</p>
              <ul>
                <li><strong>One-time Setup / Onboarding Fees:</strong> Fees paid for platform setup, custom configuration, or onboarding assistance.</li>
                <li><strong>Custom Development Fees:</strong> Any bespoke features, integrations, or module development commissioned from our team.</li>
                <li><strong>White-Label Licensing Fees:</strong> Fees for white-label branding, custom domain setup, or branded APK generation.</li>
                <li><strong>SMS & Email Credits:</strong> Pre-purchased communication credits (Twilio, Fast2SMS, Airtel, Gmail quota) once consumed or activated.</li>
                <li><strong>Add-On Module Fees:</strong> Fees for individual module add-ons purchased outside the main subscription plan.</li>
                <li><strong>Promotional / Discounted Plans:</strong> Subscriptions purchased at special discounted rates or during promotional offers.</li>
                <li><strong>Accounts Suspended for ToS Violation:</strong> No refund will be issued if the account was suspended or terminated due to a violation of our Terms of Service.</li>
              </ul>
            </div>}
          </div>

          {/* 5 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(5)}>
              <span style={s.accNum}>05</span>
              <span style={s.accTitle}>Module-Specific Subscriptions</span>
              <span style={{ ...s.accChev, transform: open===5?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===5 && <div style={s.accBody}>
              <p>Tracklio Hub offers module-based subscriptions (CRM, HRMS, Hospital Management, MDM, Inventory, Wallet, etc.). The following applies:</p>
              <ul>
                <li>Individual module subscriptions follow the same monthly/annual refund terms above.</li>
                <li>Downgrading from a higher-tier module to a lower tier does not entitle you to a refund for the difference — the change takes effect from the next billing cycle.</li>
                <li>Upgrading a module subscription results in a pro-rated charge for the remainder of the billing period. The upgraded amount is non-refundable.</li>
                <li>If you remove a module mid-subscription, you retain access until the end of the billing period. No refund is issued for the removed module.</li>
              </ul>
            </div>}
          </div>

          {/* 6 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(6)}>
              <span style={s.accNum}>06</span>
              <span style={s.accTitle}>Cancellation Process</span>
              <span style={{ ...s.accChev, transform: open===6?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===6 && <div style={s.accBody}>
              <p>To cancel your subscription or request a refund:</p>
              <ol style={{ paddingLeft:20 }}>
                <li style={{ marginBottom:10 }}>Log in to your Tracklio Hub dashboard and navigate to <strong>Subscriptions → Manage Plan</strong>.</li>
                <li style={{ marginBottom:10 }}>Click <strong>"Cancel Subscription"</strong> and follow the on-screen instructions.</li>
                <li style={{ marginBottom:10 }}>For refund requests, email <a href="mailto:billing@trackliohub.com">billing@trackliohub.com</a> with your registered email, company name, subscription ID, and reason for cancellation.</li>
                <li style={{ marginBottom:10 }}>Our billing team will respond within <strong>3-5 business days</strong>.</li>
                <li style={{ marginBottom:10 }}>Approved refunds are processed to the original payment method within <strong>7-10 business days</strong>.</li>
              </ol>
              <div className="policy-note blue">
                ℹ️ Bank processing times may vary. UPI/net banking refunds typically arrive faster than credit card refunds.
              </div>
            </div>}
          </div>

          {/* 7 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(7)}>
              <span style={s.accNum}>07</span>
              <span style={s.accTitle}>Service Downtime & Credits</span>
              <span style={{ ...s.accChev, transform: open===7?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===7 && <div style={s.accBody}>
              <ul>
                <li>If Tracklio Hub experiences unplanned downtime exceeding <strong>4 consecutive hours</strong>, affected accounts may be eligible for a service credit equivalent to 1 day of subscription.</li>
                <li>Scheduled maintenance windows (announced 24 hours in advance) are not eligible for credits.</li>
                <li>Service credits are applied to the next billing cycle and are not transferable or redeemable for cash.</li>
                <li>Credits are not issued for outages caused by third-party services (payment gateways, SMS providers, Firebase, etc.) or force majeure events.</li>
              </ul>
            </div>}
          </div>

          {/* 8 */}
          <div style={s.accItem}>
            <button style={s.accBtn} onClick={() => toggle(8)}>
              <span style={s.accNum}>08</span>
              <span style={s.accTitle}>Disputes & Chargebacks</span>
              <span style={{ ...s.accChev, transform: open===8?"rotate(180deg)":"rotate(0deg)" }}>▾</span>
            </button>
            {open===8 && <div style={s.accBody}>
              <ul>
                <li>We encourage you to contact us at <a href="mailto:billing@trackliohub.com">billing@trackliohub.com</a> before initiating a chargeback with your bank or payment provider.</li>
                <li>Unauthorized chargebacks may result in immediate account suspension and recovery of costs.</li>
                <li>If a chargeback is filed in error and subsequently reversed, account access may be restored within 5 business days.</li>
                <li>All disputes are governed by Indian law and subject to the jurisdiction of courts in Delhi, India.</li>
              </ul>
            </div>}
          </div>

        </div>

        {/* Contact */}
        <div style={s.contactCard}>
          <h2 style={s.contactTitle}>Billing Support</h2>
          <p style={s.contactSub}>Have a question about a charge or need to request a refund?</p>
          <div style={s.contactRow}>
            <a href="mailto:billing@trackliohub.com" style={s.contactBtn}>📧 billing@trackliohub.com</a>
            <a href="https://trackliohub.com" style={s.contactBtn}>🌐 trackliohub.com</a>
          </div>
          <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13, marginTop:16 }}>
            Response time: 3–5 business days &nbsp;·&nbsp; Refund processing: 7–10 business days
          </p>
        </div>

        <p style={s.footer}>© 2026 Tracklio Hub · All rights reserved · Delhi, India</p>
      </div>
    </div>
  );
};

const s = {
  page: { minHeight:"100vh", background:"#f1f5f9", padding:"32px 16px", fontFamily:"'Segoe UI',Roboto,sans-serif" },
  wrap: { maxWidth:860, margin:"0 auto" },

  hero: { background:"linear-gradient(135deg,#065f46 0%,#1e293b 100%)", borderRadius:16, padding:"52px 40px", textAlign:"center", color:"#fff", marginBottom:20 },
  badge: { display:"inline-block", backgroundColor:"rgba(255,255,255,0.15)", padding:"6px 18px", borderRadius:20, fontSize:13, fontWeight:600, letterSpacing:1, marginBottom:18, textTransform:"uppercase" },
  h1: { fontSize:32, fontWeight:800, margin:"0 0 14px", lineHeight:1.2 },
  heroSub: { fontSize:16, color:"rgba(255,255,255,0.8)", lineHeight:1.7, maxWidth:600, margin:"0 auto 12px" },
  heroDate: { fontSize:13, color:"rgba(255,255,255,0.5)" },

  summaryGrid: { display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))", gap:14, marginBottom:20 },
  summaryCard: { background:"#fff", borderRadius:12, padding:"20px 18px", boxShadow:"0 1px 4px rgba(0,0,0,0.07)" },
  summaryIcon: { fontSize:26, marginBottom:10 },

  accordion: { display:"flex", flexDirection:"column", gap:8, marginBottom:24 },
  accItem: { background:"#fff", borderRadius:12, overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.07)" },
  accBtn: { width:"100%", display:"flex", alignItems:"center", gap:14, padding:"18px 22px", border:"none", background:"none", cursor:"pointer", textAlign:"left" },
  accNum: { fontSize:11, fontWeight:700, color:"#059669", backgroundColor:"#ecfdf5", padding:"3px 8px", borderRadius:6, flexShrink:0 },
  accTitle: { flex:1, fontSize:15, fontWeight:600, color:"#1e293b" },
  accChev: { fontSize:18, color:"#64748b", transition:"transform 0.2s", flexShrink:0 },
  accBody: { padding:"4px 22px 22px 22px", fontSize:14, color:"#374151", lineHeight:1.8, borderTop:"1px solid #f1f5f9" },

  contactCard: { background:"linear-gradient(135deg,#065f46,#1e293b)", borderRadius:14, padding:"36px 32px", textAlign:"center", color:"#fff", marginBottom:20 },
  contactTitle: { fontSize:22, fontWeight:700, margin:"0 0 8px" },
  contactSub: { fontSize:14, color:"rgba(255,255,255,0.7)", margin:"0 0 20px" },
  contactRow: { display:"flex", flexWrap:"wrap", gap:12, justifyContent:"center" },
  contactBtn: { backgroundColor:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.2)", padding:"10px 24px", borderRadius:30, fontSize:14, color:"#fff", textDecoration:"none" },

  footer: { textAlign:"center", fontSize:13, color:"#94a3b8", marginTop:8 },
};

const css = `
  .acc-btn:hover { background:#f8faff !important; }
  .acc-body ul, .acc-body ol { padding-left:22px; margin:8px 0; }
  .acc-body li { margin-bottom:8px; }
  .acc-body a { color:#059669; }
  .policy-note { padding:12px 16px; border-radius:8px; margin-top:14px; font-size:13px; line-height:1.7; }
  .policy-note.yellow { background:#fffbeb; border:1px solid #fde68a; color:#78350f; }
  .policy-note.blue { background:#eff6ff; border:1px solid #bfdbfe; color:#1e3a5f; }
  .policy-table-wrap { margin-top:16px; overflow-x:auto; }
  .policy-table { width:100%; border-collapse:collapse; font-size:13px; }
  .policy-table th { background:#f1f5f9; padding:10px 14px; text-align:left; font-weight:600; color:#475569; border:1px solid #e2e8f0; }
  .policy-table td { padding:10px 14px; border:1px solid #e2e8f0; color:#374151; }
  .policy-table td.green { color:#15803d; font-weight:600; }
  .policy-table td.yellow { color:#b45309; font-weight:600; }
  .policy-table td.red { color:#dc2626; font-weight:600; }
`;

export default RefundPolicy;